import React from "react";
import {
  FaHtml5, FaCss3Alt, FaJs, FaReact, FaPython, FaGitAlt, FaDatabase,
} from "react-icons/fa";
import { DiVisualstudio } from "react-icons/di";
import {
  SiPandas, SiNumpy, SiScikitlearn, SiTensorflow, SiKeras, SiOpencv,
  SiOpenai, SiHuggingface, SiJupyter, SiGooglecolab, SiStreamlit, SiDbt,
} from "react-icons/si";

// ARMED = production-ready · FORGING = in development.
// icons kept from the original; styling adapted to the paper theme.
const armed = [
  { name: "Python", icon: <FaPython /> },
  { name: "SQL", icon: <FaDatabase /> },
  { name: "pandas", icon: <SiPandas /> },
  { name: "NumPy", icon: <SiNumpy /> },
  { name: "scikit-learn", icon: <SiScikitlearn /> },
  { name: "Streamlit", icon: <SiStreamlit /> },
  { name: "OpenCV", icon: <SiOpencv /> },
  { name: "Git", icon: <FaGitAlt /> },
  { name: "React", icon: <FaReact /> },
  { name: "JavaScript", icon: <FaJs /> },
  { name: "HTML", icon: <FaHtml5 /> },
  { name: "CSS", icon: <FaCss3Alt /> },
];

const forging = [
  { name: "TensorFlow", icon: <SiTensorflow /> },
  { name: "Keras", icon: <SiKeras /> },
  { name: "OpenAI", icon: <SiOpenai /> },
  { name: "Hugging Face", icon: <SiHuggingface /> },
  { name: "dbt", icon: <SiDbt /> },
];

const tools = [
  { name: "Power BI" }, { name: "Looker Studio" }, { name: "Google Sheets" },
  { name: "MS Excel" }, { name: "Jupyter", icon: <SiJupyter /> },
  { name: "Google Colab", icon: <SiGooglecolab /> }, { name: "VS Code", icon: <DiVisualstudio /> },
];

const Cell = ({ s, forging, index }) => (
  <div className={`skill-cell ${forging ? "forging" : ""}`} data-aos="fade-up" data-aos-delay={index * 40}>
    {s.icon && <span className="skill-ic">{s.icon}</span>}
    <span className="skill-name">{s.name}</span>
    {forging && <span className="skill-tag">forging</span>}
  </div>
);

const Skillsets = () => (
  <div className="sec" id="skills">
    <div className="wrap">
      <div className="sec-h"><span className="hash">##</span> capability matrix</div>

      <div className="skill-label">▰ armed — production</div>
      <div className="skill-grid">
        {armed.map((s, i) => <Cell key={s.name} s={s} index={i} />)}
      </div>

      <div className="skill-label" style={{ marginTop: 28 }}>▱ forging — in development</div>
      <div className="skill-grid">
        {forging.map((s, i) => <Cell key={s.name} s={s} forging index={i} />)}
      </div>

      <div className="skill-label" style={{ marginTop: 28 }}>{"// tooling"}</div>
      <div className="skill-grid">
        {tools.map((s, i) => <Cell key={s.name} s={s} index={i} />)}
      </div>
    </div>
  </div>
);

export default Skillsets;